// Запросы к API: JSON туда и обратно, ошибки — по-русски, текстом для пользователя
export interface ApiOptions {
  method?: 'GET' | 'POST' | 'DELETE';
  body?: unknown;
  /** дополнительные заголовки (например, Authorization для аккаунта) */
  headers?: Record<string, string>;
  /** сколько ждать ответа, мс (по умолчанию минута: первый запрос мест города к Overpass идёт до 60 с); 0 — без ограничения */
  timeout?: number;
}

/** Сервер не ответил вовремя — запрос прерван, кнопку поиска можно нажать снова */
export const TIMEOUT_MESSAGE = 'Сервер долго не отвечает. Попробуйте ещё раз.';
/** Запрос не дошёл до сервера (нет интернета) */
export const OFFLINE_MESSAGE = 'Нет связи с сервером';
const DEFAULT_TIMEOUT = 60_000;

/** Ошибка API: текст для пользователя и статус HTTP (401 — нужен вход) */
export type ApiError = Error & { status?: number };

export async function api<T>(url: string, opts: ApiOptions = {}): Promise<T> {
  const { method = 'GET', body, headers, timeout = DEFAULT_TIMEOUT } = opts;
  const ctrl = typeof AbortController === 'function' && timeout > 0 ? new AbortController() : null;
  const timer = ctrl ? setTimeout(() => ctrl.abort(), timeout) : 0;
  let r: Response;
  let data: unknown;
  try {
    try {
      r = await fetch(url, {
        method,
        headers: body || headers ? { ...(body ? { 'Content-Type': 'application/json' } : {}), ...headers } : undefined,
        body: body ? JSON.stringify(body) : undefined,
        ...(ctrl ? { signal: ctrl.signal } : {}),
      });
    } catch {
      throw new Error(ctrl?.signal.aborted ? TIMEOUT_MESSAGE : OFFLINE_MESSAGE);
    }
    data = await r.json().catch(() => {
      if (ctrl?.signal.aborted) throw new Error(TIMEOUT_MESSAGE);
      return {};
    });
  } finally {
    if (timer) clearTimeout(timer);
  }
  if (!r.ok) {
    const msg = data && typeof data === 'object' && 'error' in data ? (data as { error?: unknown }).error : null;
    throw Object.assign(new Error(typeof msg === 'string' && msg ? msg : `Ошибка ${r.status}`), { status: r.status });
  }
  return data as T;
}
